import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h4, paragraph } from '@helpers/typography';
import { ButtonStyles } from '@stories/Components/Buttons/GeneralButton/Button.styles';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import FieldStyles from '@stories/Components/ZohoForms/Components/Field/Field.styles';
import RecaptchaStyles from '@stories/Components/ZohoForms/Components/Recaptcha/Recaptcha.styles';
import ZohoFormStyles from '@stories/Components/ZohoForms/Forms/Forms.styles';
import styled from 'styled-components';
import { slimFormOverrides } from '../Form/Form.styles';
const Container = styled(SectionWrapper) ``;
const Inner = styled.div ``;
const Title = styled.h2 `
  ${h4};
  font-size: ${fluid(30, 40)};
  line-height: ${fluid(40, 70)};
  color: var(--titleColor);
  position: relative;
  margin-bottom: ${fluid(23, 38)};
`;
const ContentWrapper = styled.div ``;
const Grid = styled.div `
  ${baseGrid};
  gap: var(--gutterWidth);
`;
const Column = styled.div `
  grid-column: 1 / span 12;
  display: flex;
  flex-direction: column;
  gap: var(--gutterWidth);

  @media ${until(Device.TabletLarge)} {
    order: 2;

    &[data-has-non-text='true'] {
      order: 1;
    }
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: span 6;
  }
`;
const Content = styled.div `
  ${paragraph}
  ${contentStyles};

  width: 100%;
  text-align: left;

  [data-text-align='right'] & {
    text-align: right;
  }

  [data-text-align='center'] & {
    text-align: center;
  }

  a {
    display: inline;
  }

  img {
    width: 100%;
    width: 100%;
    max-width: 50%;
    display: block;
    margin: 0 auto 40px;

    @media ${from(Device.Tablet)} {
      float: right;
      max-width: 300px;
      width: auto;
      margin-left: 10px;
      margin-bottom: 10px;
    }
  }
`;
const BlogMediaWrapper = styled.div ``;
const MediaHolder = styled.div `
  /* aspect-ratio: 854 / 637;
  
  overflow: hidden; */
`;
const Image = styled.img `
  display: block;
  /* width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center; */
  border-radius: 25px;
`;
const Caption = styled.div `
  ${fonts.montserrat.light};
  font-size: ${fluid(16, 19)};
  line-height: ${fluid(32, 32)};
  margin-top: ${fluid(16, 24)};

  span {
    ${fonts.montserrat.regular};
  }
`;
const CallToAction = styled.div `
  padding-top: 0;
  grid-column: 2 / span 10;

  @media ${until(Device.Tablet)} {
    grid-column: span 12;
  }

  [data-text-align='left'] & {
    text-align: left;
  }

  [data-text-align='right'] & {
    text-align: right;
  }

  [data-text-align='center'] & {
    text-align: center;
  }
`;
const Form = styled.div `
  padding: ${fluid(32, 40)} ${fluid(17, 48)};
  background-color: ${brand.yellow.light};
  border-radius: ${fluid(24, 48)};
  margin-bottom: var(--sectionSpacing);

  ${slimFormOverrides}

  /* Right align the recaptcha box on desktop devices */

  @media ${from(Device.TabletLarge)} {
    form {
      display: grid;
      column-gap: 16px;
      grid-template-columns: auto 256px;

      ${ZohoFormStyles.Disclaimer},
      ${FieldStyles.Field} {
        grid-column: 1 / -1;
      }

      ${RecaptchaStyles.RecaptchaWrapper} {
        grid-column: 2;
        margin: auto 0 0;
      }

      ${ButtonStyles.Button}[type='submit'] {
        margin-right: auto;
      }

      ${RecaptchaStyles.RecaptchaWrapper},
      > ${ButtonStyles.Button}[type='submit'] {
        grid-row: 99;
      }
    }
  }
`;
const FormTitle = styled.p `
  margin: 0;
  ${fonts.lustria.regular};
  font-size: ${fluid(26, 32)};
  line-height: 1;
  margin-bottom: 32px;
`;
const SplitAuthorMediaStyles = {
    BlogMediaWrapper,
    Container,
    Content,
    Grid,
    Column,
    Caption,
    Image,
    Inner,
    MediaHolder,
    Title,
    CallToAction,
    ContentWrapper,
    Form,
    FormTitle,
};
export default SplitAuthorMediaStyles;
